import messages from './messages.json';
import { flushSync } from 'react-dom';

export const AIR_PLUS_LANGUAGE_EVENT = 'airplus_lang_changed';
let currentLanguage;
let languageTransition;
let languageChange = 0;
export const getAirPlusLanguage = () => {
  if (currentLanguage) return currentLanguage;
  try { return localStorage.getItem('airplus_lang') === 'ko' ? 'ko' : 'en'; } catch (_) { return 'en'; }
};
export const setAirPlusLanguage = value => {
  const next = value === 'ko' ? 'ko' : 'en';
  if (next === getAirPlusLanguage() && !languageTransition) return;
  const change = ++languageChange;
  const commit = () => {
    if (change !== languageChange) return;
    currentLanguage = next;
    try { localStorage.setItem('airplus_lang', currentLanguage); } catch (_) { /* The in-memory preference still works. */ }
    // Commit every subscriber together before the transition takes its snapshot.
    flushSync(() => window.dispatchEvent(new CustomEvent(AIR_PLUS_LANGUAGE_EVENT, { detail: currentLanguage })));
  };
  languageTransition?.skipTransition();
  if (typeof document.startViewTransition === 'function' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    const transition = document.startViewTransition(commit);
    languageTransition = transition;
    transition.finished.catch(() => {}).finally(() => { if (languageTransition === transition) languageTransition = undefined; });
  } else commit();
};
export const syncAirPlusLanguage = event => {
  if (event?.type === 'storage' && event.key && event.key !== 'airplus_lang') return getAirPlusLanguage();
  if (event?.detail === 'en' || event?.detail === 'ko') currentLanguage = event.detail;
  else {
    currentLanguage = undefined;
    currentLanguage = getAirPlusLanguage();
  }
  return getAirPlusLanguage();
};
const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const templates = Object.entries(messages).filter(([source]) => /\{\d+\}/.test(source) && source.replace(/\{\d+\}/g, '').trim().length > 2).map(([source, pair]) => {
  const indices = [];
  const parts = source.split(/(\{\d+\})/g).map(part => {
    const token = part.match(/^\{(\d+)\}$/);
    if (token) { indices.push(Number(token[1])); return '(.+?)'; }
    return escapePattern(part);
  });
  return { pattern: new RegExp(`^${parts.join('')}$`), pair, indices };
});
export function translateAirPlus(value, language = getAirPlusLanguage(), values = []) {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  let pair = messages[trimmed];
  if (!pair) {
    for (const template of templates) {
      const match = trimmed.match(template.pattern);
      if (!match) continue;
      pair = template.pair;
      values = [...values];
      template.indices.forEach((index, position) => { values[index] = match[position + 1]; });
      break;
    }
  }
  if (!pair) return value;
  const result = pair[language === 'ko' ? 1 : 0].replace(/\{(\d+)\}/g, (token, index) => values[index] == null ? token : String(values[index]));
  return value.slice(0, value.indexOf(trimmed)) + result + value.slice(value.indexOf(trimmed) + trimmed.length);
}
// For UI helpers outside React components. User-authored content is never passed here.
export const airPlusText = (value, ...values) => translateAirPlus(value, getAirPlusLanguage(), values);
